/**
 * EfacturaIcon — pictogramă inline pentru fluxul ANAF e-Factura.
 *
 * Sursă: `pictograme/Asset 1.svg` (logo simbolic ANAF e-Factura folosit pe
 * documentația softfactura.ro). Inline ca React component → permite colorare
 * via `currentColor` și nu necesită network request.
 *
 * Aspect ratio: 188.64 × 142.43 (≈1.32:1). Renderează well la heights
 * mici (14-20px) pentru badge-uri în sidebar / butoane secundare.
 */

interface EfacturaIconProps {
  className?: string;
  /** Înălțime în px. Lățimea e calculată automat din aspect ratio. */
  size?: number;
  'aria-hidden'?: boolean;
}

export function EfacturaIcon({
  className = '',
  size = 14,
  'aria-hidden': ariaHidden,
}: EfacturaIconProps) {
  const width = Math.round((size * 188.64) / 142.43);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 188.64 142.43"
      width={width}
      height={size}
      className={className}
      role={ariaHidden ? undefined : 'img'}
      aria-label={ariaHidden ? undefined : 'e-Factura ANAF'}
      aria-hidden={ariaHidden}
    >
      <path
        fill="currentColor"
        d="M81.51,119.1c-14.45-.89-28.12-7.93-28.5-23.98,32.39,4.66,72.59-8.06,92.41-35.08C166.86,30.81,157.77-2.38,117.51.13,79.8,2.49,44.89,32.72,33.99,68.12l-23.97-9L0,80.12v1l28.83,10.17c.63,29.48,19.28,48.69,48.63,50.87,26.53,1.97,44.24-7.09,64.44-22.64,14.9-11.48,28.49-27.56,46.74-33.28v-25.05c-40.05,7.43-64.64,60.53-107.13,57.91ZM112.75,24.37c3.91-.69,16.22-1.74,19.02.98,3.88,3.76-.99,13.9-3.35,17.69-13.65,21.86-46.94,32.22-71.42,29.07,9.72-22.65,30.8-43.32,55.75-47.74Z"
      />
    </svg>
  );
}
